<div>

    <form [formGroup]="form">
        <!-- X -->
        <div formArrayName="Xs">
            <div *ngFor="let X of form['controls'].Xs['controls']; let ix=index">
                <div formGroupName="{{ix}}" class="Xs">
                    <input type="text" formControlName="X">
                    <!-- Y -->
                    <div formArrayName="Ys">
                        <div *ngFor="let Y of X['controls'].Ys['controls']; let iy=index">
                            <div formGroupName="{{iy}}" class="Ys">
                                <input type="text" formControlName="Y1">
                                <input type="text" formControlName="Y2">
                            </div>
                        </div>
                        <input type="button" (click)="addY(ix)" value="Add Y">
                    </div>
                    <!-- Y End-->
                </div>
            </div>
            <input type="button" (click)="addX()" value="Add X">
        </div>
    </form>
    <!-- X End -->

    <h5>Field Values</h5>
    <pre style="font-size:15px">{{ form.value | json }}</pre>


    <form [formGroup]="processForm">


        <mat-form-field>
            <input matInput matInputAutofocus #inputProcessName formControlName="name" type="text" id="inputProcessName"
                   aria-describedby="inputProcessName"
                   placeholder="Name">
        </mat-form-field>
        <mat-form-field>
            <textarea matInput #inputProcessName formControlName="description" placeholder="Description"></textarea>
        </mat-form-field>
        <!--    <mat-form-field>-->
        <!--        <mat-label>Step Type</mat-label>-->
        <!--        <mat-select formControlName="processType" [compareWith]="compareProcessTypes">-->
        <!--            <mat-option *ngFor="let processType of processTypes" [value]="processType">-->
        <!--                {{processType.name}}-->
        <!--            </mat-option>-->
        <!--        </mat-select>-->
        <!--    </mat-form-field>-->
        <mat-checkbox formControlName="publicOutputInd">Is Output Viewable?</mat-checkbox>
        <mat-form-field *ngIf="processForm.controls['publicOutputInd'].value == true">
            <input matInput formControlName="outputName" type="text" aria-describedby="outputName"
                   placeholder="Output Name">
        </mat-form-field>

        <hr/>
        <div class="process-property-container">
            <h5>Property Sets</h5>


            <div formArrayName="propertySets">
                <div *ngFor="let propertySet of processForm['controls'].propertySets['controls']; let propertySetsIndex = index">
                    <div [formGroupName]="propertySetsIndex">
                        <mat-form-field class="process-property">
                            <input matInput formControlName='name' placeholder="Property Set Name">
                        </mat-form-field>

                        <div formArrayName="properties">
                            <div *ngFor="let property of propertySet['controls'].properties['controls']; let propertyIndex = index">
                                <div [formGroupName]="propertyIndex">
                                    <mat-form-field class="process-property">
                                        <input matInput formControlName='name' placeholder="Name">
                                    </mat-form-field>
                                    <mat-form-field class="process-property">
                                        <input matInput formControlName='value' placeholder="Value">
                                    </mat-form-field>
                                                                            <button mat-icon-button
                                                                                    (click)="deleteProcessProperty(propertySetsIndex, propertyIndex)"
                                                                                    class="process-property-delete" color="accent" aria-label="Delete property"
                                                                            >
                                                                                <mat-icon>delete</mat-icon>
                                                                            </button>
                                </div>
                            </div>
                        </div>

                        <button mat-button mat-flat-button color="accent" type="button"
                                (click)="addProcessProperty(propertySetsIndex)">Add Property
                        </button>
                        <button mat-icon-button
                                (click)="deletePropertySet(propertySetsIndex)"
                                class="process-property-delete" color="accent" aria-label="Delete property set"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>

                    </div>
                </div>

                <button mat-button mat-flat-button color="primary" type="button" (click)="addPropertySet()">Add Set
                </button>

            </div>
        </div>
    </form>

    <h5>Process Form Field Values</h5>
    <pre style="font-size:15px">{{ processForm.value | json }}</pre>

</div>